import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { Business, Edit } from '@mui/icons-material';

interface CompanyInfoBoxProps {
  companyName: string;
  onEdit: () => void;
}

export const CompanyInfoBox: React.FC<CompanyInfoBoxProps> = ({
  companyName,
  onEdit,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        mb: 3,
        border: 1,
        borderColor: 'grey.300',
        borderRadius: 1,
        bgcolor: 'action.hover',
      }}
    >
      <Business color="action" data-testid="BusinessIcon" />
      <Typography variant="body1" sx={{ flex: 1 }}>
        {companyName}
      </Typography>
      <Tooltip title="Alterar empresa">
        <IconButton
          size="small"
          onClick={onEdit}
          aria-label="Alterar empresa"
        >
          <Edit fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
